"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    ToggleSwitch: {
      position: 'relative',
      display: 'inline-block',
      width: 32,
      height: 20,
      margin: 0,
      '& input': {
        opacity: 0,
        width: 0,
        height: 0
      },
      '& .toggle-switch-slider': {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme['$toggle-switch-background'],
        '-webkit-transition': '.4s',
        transition: '.4s',
        borderRadius: 10
      },
      '& .toggle-switch-slider:before': {
        position: 'absolute',
        content: '""',
        height: 14,
        width: 14,
        left: 3,
        bottom: 3,
        backgroundColor: theme['$toggle-switch-slider'],
        '-webkit-transition': '.4s',
        transition: '.4s',
        borderRadius: '50%'
      },
      '& input:checked + .toggle-switch-slider': {
        backgroundColor: theme['$toggle-switch-checked']
      },
      '& input:focus + .toggle-switch-slider': {
        boxShadow: '0 0 1px #2196F3'
      },
      '& input[disabled] + .toggle-switch-slider, input[readonly] + .toggle-switch-slider': {
        cursor: 'not-allowed'
      },
      '& input:checked + .toggle-switch-slider:before': {
        '-webkit-transform': 'translateX(12px)',
        '-ms-transform': 'translateX(12px)',
        transform: 'translateX(12px)'
      }
    },
    Disabled: {
      opacity: 0.3
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map